export const doubleVerifyScriptUrl = "https://pub.doubleverify.com/dvtag/24434720/DV1462763/pub.js";

/**
 * Script from Double verify
 * Refer to https://support.doubleverify.com/support/solutions/articles/22000284278-unity-tag-integration
 * JavaScript implementation to properly queue ad requests until the Unity Tag is ready
 * Do not update unless verify with doubleVerify
 */
/* eslint-disable */
export const doubleVerifyInitScript = () => {
    window.onDvtagReady = function(callback, timeout = 750) {
        window.dvtag = window.dvtag || {};
        dvtag.cmd = dvtag.cmd || [];
        const opt = { callback, timeout, timestamp: new Date().getTime() };

        dvtag.cmd.push(() => { dvtag.queueAdRequest(opt) });
        setTimeout(() => {
            const cb = opt.callback;

            opt.callback = null;
            if (cb) {
                cb();
            }
        }, timeout);
    };
};
